module.exports = __webpack_public_path__ + "img/product-banner.b3d66056.png";